export const SITE = {
  name: "爆料专区",
  shortName: "爆料专区",
  tagline: "今日热点新鲜事 · 吃瓜合集每日更新",
  description:
    "爆料专区聚合全网今日热点、新鲜事与吃瓜合集，每日更新明星八卦、社会趣事、网络热闻、情感八卦与影视综艺爆料，帮你快速掌握最新猛料。",
  keywords: "爆料专区,今日热点,新鲜事,吃瓜合集,明星八卦,网络热闻",
  email: "hello@baoliao-zhuanqu.com",
  domain: "https://dixiaz45.cn",
  nav: [
    { label: "首页", to: "/" },
    { label: "明星八卦", to: "/category/mingxing" },
    { label: "社会趣事", to: "/category/shehui" },
    { label: "网络热闻", to: "/category/wangluo" },
    { label: "情感八卦", to: "/category/qinggan" },
    { label: "影视综艺", to: "/category/yingshi" },
    { label: "关于我们", to: "/about" },
  ],
};